import React from 'react';
import ReactDOM from 'react-dom';
import GongqiFormItem from './GongqiFormItem';
import CommandResolver from '../utils/CommandResolver';
import CommandTask from '../forms/sys/remote/CommandTask';
import Cmd from '../forms/sys/remote/Cmd';
import {CommandMapEditorsStore} from '../stores/CommandStore';
import {RefreshPluginStore} from '../stores/CmdTypeStore';

export default class FormItemPluginHtml extends GongqiFormItem
{
	CHANGE_URL="changeURL";
	CALL_IFRAMEM_METHOD="callIFrameMethod";
	
	constructor(props)
	{
		super(props);
		this.unsubscribeRefreshPluginStore = RefreshPluginStore.listen(this.onRefresh.bind(this));
	}

	componentWillUnmount()
	{
		this.unsubscribeRefreshPluginStore();
	}

	onRefresh(task,pluginName,formId,result)
	{
		if(this.props.xml.name == pluginName && this.props.formId == formId)
		{
			result.push(this.props.xml.name);
			this.refresh(task);
		}
	}

	/*componentDidMount()
	{
		if($(this.parentNode).height()!=$(this.iframeNode).height())
		{
			$(this.iframeNode).height($(this.parentNode).height());
		}
	}*/

	refresh(task)
	{
		if(this.iframeNode)
		{
			var htmlrefresharg = task.arg;
			if(htmlrefresharg.opr == this.CHANGE_URL)
			{

				//TODO  plugin  在os内部跳转时  需要固定的 ip前缀
				if(window.parent.window.didomain && window.parent.window.appId){
					//$(this.iframeNode).attr("src","appCustomClient/"+htmlrefresharg.arg);
					if(htmlrefresharg.arg.startsWith("/")){
						htmlrefresharg.arg="."+htmlrefresharg.arg;
					}
					$(this.iframeNode).attr("src",htmlrefresharg.arg);
				}else{
					$(this.iframeNode).attr("src",htmlrefresharg.arg);
				}
				//$(this.iframeNode).load(htmlrefresharg.arg);
			}
			else if(htmlrefresharg.opr == this.CALL_IFRAMEM_METHOD)
			{
				//TODO 取消CommandArg的情况 allowEdit固定为true
				var funcName = htmlrefresharg.arg;
				
				if(htmlrefresharg.addClientInfo)
				{
					let _parentWindow = window.parent.window;
					if(htmlrefresharg.iframeFuncArg == null)
						htmlrefresharg.iframeFuncArg = [];
					let commandArg = {};
					try
					{
						CommandResolver.regCmdArgGroup(this.module,commandArg,this.props.control.group,
							false,true,true,false,true,true);
					}
					catch(err)
					{
						
					}
					
					htmlrefresharg.iframeFuncArg.push(
					{
						allowEdit:true,
						userId:_parentWindow.userInfos.userId,
						userGroups:_parentWindow.userInfos.userGroups,
						commandArg:commandArg
					});
				}
				let win = this.iframeNode.window || this.iframeNode.contentWindow;
				let fn = win[funcName];
				let funcArg = htmlrefresharg.iframeFuncArg;
				if(typeof fn === 'function')
				{
					fn.apply(null,funcArg);
				}
				
			}
		}
	}

	changeFrameHeight()
	{
		return;
		var doc = this.iframeNode.contentWindow.document;
		$(this.iframeNode).height(doc.documentElement.clientHeight);

	}

	componentDidMount()
	{
		let key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
		if(window.hasOwnProperty(key))
		{
			let pluginLaterArg = window[key];
			let tasks = pluginLaterArg.tasks;
			for(let i = 0;i<tasks.length;i++)
			{
				this.refresh(tasks[i]);
			}
			window[key] = null;
			delete window[key];
		}
	}

	/*window.onresize=function()
	{  
	     this.changeFrameHeight();  

	}*/
	/*<div style={{_style}} ref={node => this.iframeNode = node}></div>*/
	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		//_style.display = 'flex';
		if(!this.props.control.getProperty_Visible() && !this.props.control.getProperty_PlaceHolder()){
			_style.display='none';
		}
		_style = Object.assign(_style,{border:'none',boxShadow:'0 1px 1px rgba(0, 0, 0, 0.1)',borderRadius:'3px'});
		return  <iframe onLoad={this.changeFrameHeight.bind(this)} style={_style} id={"htmlPlugin"+this.props.xml.id} ref={node => this.iframeNode = node}>
				</iframe>;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/FormItemPluginHtml.js